// extracted by mini-css-extract-plugin
module.exports = {"modal":"PhotoGallery_modal__3vGZL","galleryBackdrop":"PhotoGallery_galleryBackdrop__35p9E","close":"PhotoGallery_close__1Eq3p","carouselWrap":"PhotoGallery_carouselWrap__2-oJR"};